import { useAccessKeys } from '@api/accessKeys';
import { DataGrid } from '@components/DataGrid';
import { Box } from '@mui/system';
import { DataGridProProps, GridRowParams } from '@mui/x-data-grid-pro';
import { getAccessKeysColumns } from '@utils/tables';
import { ACCESS_KEYS_FIELDS } from 'constants/global';
import React from 'react';
import { AccessKeyStatus, IAccessKey } from 'types/accessKeys';
import { IDataGridProps } from 'types/common';
import AccessKeyDeleteDialog from './Dialogs/DeleteDialog';
import AccessKeyEditDialog from './Dialogs/EditDialog';
import AccessKeyStatusDialog from './Dialogs/StatusDialog';

interface IAccessKeysTableProps
	extends Partial<IDataGridProps & DataGridProProps> {}

const AccessKeysTable: React.FC<IAccessKeysTableProps> = ({
	...dataGridProps
}) => {
	const { data, isLoading } = useAccessKeys();
	const columns = getAccessKeysColumns();

	const getRowActions = (params: GridRowParams) => {
		const item = params.row as IAccessKey;
		const isActive = item.status === AccessKeyStatus.active;
		return [
			{
				key: 'edit',
				label: intl.tr('button.edit'),
				Dialog: AccessKeyEditDialog
			},
			{
				key: isActive ? 'deactivate' : 'activate',
				label: isActive
					? intl.tr('button.deactivate')
					: intl.tr('button.activate'),
				Dialog: AccessKeyStatusDialog
			},
			{
				key: 'delete',
				label: intl.tr('button.delete'),
				Dialog: AccessKeyDeleteDialog
			}
		];
	};

	return (
		<Box display="flex" flexGrow={1} data-testid="accessKeys-table">
			<DataGrid
				noDataMessageId="grid.data.no.data.accessKeys"
				rows={data?.data || []}
				loading={isLoading}
				getRowActions={getRowActions}
				columns={columns}
				checkboxSelection={false}
				initialState={{
					sorting: {
						sortModel: [{ field: ACCESS_KEYS_FIELDS.createdTime, sort: 'desc' }]
					}
				}}
				{...dataGridProps}
			/>
		</Box>
	);
};

export default AccessKeysTable;
